import { LicenseInfo } from '@mui/x-data-grid-pro'

const getEnvVariable = (name: string) => {
  const value = process.env[`REACT_APP_${name}`]
  if (!value) {
    throw new Error(`Environment variable ${name} is not set`)
  }
  return value
}


//Check the domain name for prod pick up the hostname directly, else pick up the domain name from env file.
let domainName = window.location.hostname;
let backendURL = `https://${domainName}/app/v1/config/frontend`;

if(process.env.NODE_ENV === 'development') {
  backendURL = getEnvVariable('CONFIG_SERVICE_URL');
}

//Call to get configs from BE API synchronously
const request = new XMLHttpRequest();
request.open('GET', backendURL, false);
request.send(null);
if (request.status !== 200) {
  console.log("error in reading the configuration !");
}

const data = JSON.parse(request.responseText);

if(process.env.NODE_ENV === 'development') {
  data.baseUrl = getEnvVariable('BASE_URL');
}

sessionStorage.setItem('configs', JSON.stringify(data));



//Method to get config parameters from local storage
export const getConfigParameters = (name: string) => {
  const configData = JSON.parse(sessionStorage.getItem("configs")!)
      return configData[name];
};

// Expiry date: 2024-03-21
LicenseInfo.setLicenseKey(getConfigParameters("muiLicenseKey"))


export const userGuideName = getConfigParameters("userGuideName")
export const ketcherHost =  getConfigParameters("ketcherHost")
export const ketcherUrl = getConfigParameters("ketcherUrl");
export const contactEmail = getConfigParameters("contactEmail");
export const smilesImagesUrl = getConfigParameters("smilesImageUrl");
export const smilesImagesSmallWidth = getConfigParameters("smilesImagesSmallWidth");
export const smilesImagesSmallHeight = getConfigParameters("smilesImagesSmallHeight");
export const smilesImagesLargeWidth = getConfigParameters("smilesImagesLargeWidth");
export const smilesImagesLargeHeight = getConfigParameters("smilesImagesLargeHeight");

export const interactiveDesignConfig = {
  importDatasetMaxSmilesCount: getConfigParameters("importDatasetMaxSmilesCount"),
}


export const adminRoutesPrefix = '/admin';

export const baseURL = getConfigParameters("baseUrl")
export const predictionBaseURL = getConfigParameters("predictionBaseUrl")
export const accessManagementBaseURL = getConfigParameters("accessManagementBaseUrl")
export const platformEnv = getConfigParameters("platformEnv")
export const endpoints = { notficationsSocket: getConfigParameters("notificationsSocket"),}
export const mongoDBChartsBaseUrl = getConfigParameters("mongodbChartsBaseURL")
export const mongoDBChartsDashboardUrl = getConfigParameters("mongodbChartsDashboardId")
export const bokehServerPath = getConfigParameters("bokehServerPath")
export const platformResourcesBucketName = getConfigParameters("platformResourcesBucketName")
export const documentViewerMaxFileSize =  parseInt(getConfigParameters("documentViewerMaxFileSize")) ||1024 * 1024 * 20;

const storages = {
  localStorage: window.localStorage,
  sessionStorage: window.sessionStorage,
}
const environmentStorage =
  storages[getConfigParameters("authStorage") as keyof typeof storages]
const storage = environmentStorage || storages.sessionStorage

export const cognitoConfig = {
  aws_cognito_region: getConfigParameters("cognitoRegion"),
  aws_user_pools_id: getConfigParameters("userPoolsId"),
  aws_user_pools_web_client_id: getConfigParameters("userPoolsWebClientId"),
  identity_pool_id: getConfigParameters("identityPoolId"),
  temp_s3_bucket: getConfigParameters("tempS3Bucket"),
  storage,
}
